import {
  AssetsMelcoModelsThread,
  ThreadsApi,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../../table/useTableErrorComponent";

export const useThreads = (productId: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<AssetsMelcoModelsThread>();

  const query = useAPIQuery(
    ThreadsApi,
    ["threads", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      const response = await api.assetThreadsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        productId,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        searchTextFields: !isEmpty(searchQuery) ? "name,code" : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
